"use client";
import React, { useState, useEffect } from "react";
import Image from 'next/image';
import { useRouter, useSearchParams } from "next/navigation";
import { default as McKinsey } from "../../public/logo.svg";
import { fetchOtpData, fetchVerifyOtp } from "../../utils/api";
import { Constants } from "@/constants/constants";
import { ArrowsClockwise } from "@phosphor-icons/react";
import { useDispatch, useSelector } from "react-redux";
import { setLan, setPhone, setToken } from "@/redux/userSlice";

export default function Login() {
    const router = useRouter();
    const dispatch = useDispatch();
    const searchParams = useSearchParams();
    const [lanId, setLanId] = useState(searchParams.get('lanid'))
    const [otp, setOtp] = useState(new Array(4).fill(""));
    const [timer, setTimer] = useState(180);
    const [getOtp, setGetOtp] = useState(false);
    const [loginSucess, setLoginSuccess] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(false);
    const [verified, setVerified] = useState(false);
    const [error, setError] = useState('');
    const [onClikedGetOtp, setOnClickedGetOtp] = useState(false);
    const [onClikedVerifyOtp, setOnClickedVerifyOtp] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const allValid = otp.every(item => item !== '' && !isNaN(item));
    const savedLanId = useSelector((state) => state.lanId?.lan);

    useEffect(() => {
        if (typeof window !== undefined) {
            if (lanId != null) {
                let lanID = searchParams.get('lanid')
                console.log(lanID,"lan id inside useeffect")
                dispatch(setLan(
                    lanId,
                ));
            } else {
                dispatch(setLan(
                    ''
                ));
            }
        }
    }, [savedLanId]);

    useEffect(() => {
        if (timer > 0) {
            const intervalId = setInterval(() => {
                setTimer(timer - 1);
            }, 1000);
            return () => clearInterval(intervalId);
        }
    }, [timer]);

    useEffect(() => {
        const phoneRegex = /^[1-9]{1}[0-9]{9}$/;
        setIsPhoneNumberValid(phoneRegex.test(phoneNumber));
    }, [phoneNumber]);

    const fetchSendOtpData = async (lanId) => {
        try {
            const response = await fetchOtpData(Number(phoneNumber), lanId)
            if (response?.data?.status === 1 || response?.data?.status === "ACCEPTED") {
                setError('');
                setGetOtp(true);
                setTimer(180);
                setOnClickedGetOtp(false);
            }
            else {
                if (response?.data?.statusCode === 429) {
                    setError("Please try again after some time.")
                }
                else {
                    const message = response?.data?.message
                    if(message.toLowerCase().includes('parameter')){
                        setError("Please enter a valid lan id in the url.")
                    }
                    else{
                        setError(Constants.login.error)
                    }
                }
                setOnClickedGetOtp(false);
                console.log("somemthing went wrong in the send otp api", response)
            }
        } catch (err) {
            if (err) {
                console.log(`send otp api fails with error-:${JSON.stringify(err)}`);
            } else {
                console.log('An unexpected error occurred.');
            }
        }

    }

    const fetchVerifyOtpData = async (phoneNumberValue, otpValue, lanId) => {
        setError('');
        try {
            const response = await fetchVerifyOtp(phoneNumberValue, otpValue, lanId);
            if (response?.data?.status === 200 || response?.data?.status === "ACCEPTED") {
                let bearerToken = response?.data?.data?.access_token;
                setError('Congratulations! You have logged in successfully');
                setLoginSuccess(true);
                handleVerifyOtp(bearerToken, phoneNumberValue);
                setVerified(false);
            }
            else if(response?.data?.data==="ErrUserMdtExist"){
                setError('Mandate already exist');
                setOnClickedVerifyOtp(false);
                setVerified(false);
            }
            else if(response?.data?.data==="ErrMaxAttemptReached"){
                setError('You have reached limit of 3 attempts');
                setOnClickedVerifyOtp(false);
                setVerified(false);
            }
            else {
                setError('Invalid Otp, Please enter correct otp')
                setOnClickedVerifyOtp(false);
                setVerified(false);
                console.log("somemthing went wrong in the send otp api")
            }
        } catch (err) {
            if (err) {
                console.log(`send otp api fails with error-:${JSON.stringify(err)}`);
            } else {
                console.log('An unexpected error occurred.');
            }
        }
    }

    const handlePhoneNumberChange = (e) => {
        setPhoneNumber(e.target.value);
    };

    const handleCheckboxChange = (e) => {
        setIsChecked(e.target.checked);
      };

    const handleChange = (element, index) => {
        if (isNaN(element.value)) return;
        setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);
        if (element.nextSibling) {
            element.nextSibling.focus();
        }
    };

    const handleGetOtpClick = () => {
        setOnClickedGetOtp(true);
        setError('');
        if (isPhoneNumberValid) {
            fetchSendOtpData(lanId);
        } else {
            alert("Please enter a valid phone number.");
        }
    };

    const handleVerifyOtp = (token, num) => {
        setTimeout(() => {
            if (otp.every((digit) => digit !== "")) {
                router.push("/verifyDetails");
                setLoginSuccess(false);
                setError('');
                setOnClickedVerifyOtp(false);
                setVerified(false);
            } else {
                alert("Please enter the OTP correctly.");
            }
        }, 1000)
        dispatch(setToken(token
        ));
        dispatch(setPhone(
            num
        ));
    };

    const validateOtp = () => {
        let str = '';
        for (let i = 0; i < otp.length; i++) {
            str += otp[i];
            if (i < otp.length - 1) {
                str += '';
            }
        }
        setOnClickedVerifyOtp(true);
        setVerified(true);
        fetchVerifyOtpData(Number(phoneNumber), Number(str), lanId);
    }

    const formatTimer = (time) => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    };

    return (
        <div className="min-h-screen flex flex-col md:flex-row">
            <div className="flex-1 flex flex-col items-center justify-center bg-blue-header p-8">
                <Image
                    onClick={() => router.push('/')}
                    src={McKinsey}
                    alt="Logo"
                    style={{ height: '70px', width: '200px', marginBottom: '1px', }}
                    className="h-10"
                />
                <div className="flex flex-col items-center">
                    <div className="relative mb-6">
                        <p className=" text-sm text-white">Confidence to make it happen</p>
                    </div>
                </div>
            </div>

            <div className={getOtp ? "flex-1 flex flex-col items-center justify-center max-h-screen bg-gray-50 p-8" : "flex-1 flex flex-col items-center justify-center p-8"}>
                {!getOtp ?
                    <form >
                        <p className="text-2xl font-semibold text-gray-800 mb-2">
                            {Constants.login.login}
                        </p>
                        <p className="mb-4 text-sm text-left text-gray-500">
                            {Constants.login.details}
                        </p>
                        <div>
                            <label htmlFor="mobile" className="mt-4 text-xs text-center text-gray-500">
                                {Constants.login.mobileNumber}
                            </label>
                            <input
                                type="tel"
                                id="mobile"
                                value={phoneNumber}
                                onChange={handlePhoneNumberChange}
                                placeholder="Mobile Number"
                                className="mt-1 mb-6 w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-green-500"
                            />
                        </div>

                        <div className=" mb-6 flex items-center">
                           
                        </div>

                        <div className="mb-6 flex items-start">
                            <input
                                type="checkbox"
                                id="loginConsent"
                                className="h-4 w-4 text-gray-500 focus:ring-green-500 border-gray-300 rounded mt-1"
                                checked={isChecked} 
                                onChange={handleCheckboxChange}
                            />
                            <label htmlFor="loginConsent" className="ml-2 text-xs text-gray-600">
                                {Constants.login.loginConsent}
                            </label>
                        </div>

                        {/* <div className=" mt-6 mb-16">
                            <a href="#" className="text-sm text-blue-header hover:underline">
                                {Constants.login.registeredNum}
                            </a>
                        </div> */}
                        {error!='' && <p className={"text-left text-blue-red text-sm pt-2 pb-2 rounded-tr-lg rounded-tl-lg"}>{error}</p>}
                        <button
                            type="button"
                            className={isPhoneNumberValid && isChecked==true ? "mb-4 w-full py-3 bg-blue-header text-white rounded-md hover:bg-blue-opacityHeader focus:outline-none focus:ring focus:ring-green-500 flex items-center justify-center" :
                                "mb-4 w-full py-3 bg-gray-300 text-gray-500 rounded-md focus:outline-none focus:ring focus:ring-green-500 cursor-not-allowed flex items-center justify-center"
                            }
                            onClick={handleGetOtpClick}
                            disabled={(!isPhoneNumberValid || onClikedGetOtp|| !isChecked)}
                        >
                            {onClikedGetOtp ? <ArrowsClockwise size={16} className="text-white animate-spin" /> : Constants.login.getOtp}
                        </button>
                        <p className="text-xs text-center text-gray-500">
                            {Constants.login.proceeding}
                            <a href="https://www.herofincorp.com/data-privacy-policy" className="text-blue-header hover:underline"
                            target="_blank" 
                            rel="noopener noreferrer">
                                {Constants.login.termsAndCondtions}
                            </a>
                        </p>
                        <p className="text-xs text-center text-gray-500">
                            {Constants.login.read}
                            <a href="https://www.herofincorp.com/data-privacy-policy" className="text-blue-header hover:underline"
                            target="_blank" 
                            rel="noopener noreferrer">
                                {Constants.login.privacyPolicy}
                            </a>
                        </p>
                    </form> :

                    <div className="flex items-start justify-center min-h-screen bg-gray-50 p-12 overflow-y-auto max-h-screen">
                        <div className="w-full max-w-sm bg-white rounded-lg shadow-lg">
                            {(loginSucess || error!='') && <p className={loginSucess ? "text-center text-white text-sm bg-blue-header mb-4 p-2 rounded-tr-lg rounded-tl-lg" : "text-center text-white text-sm bg-blue-red mb-4 p-2 rounded-tr-lg rounded-tl-lg"}>{error}</p>}
                            <div className="p-10">
                                <h2 className="text-center text-lg font-semibold text-gray-700 mb-4">
                                    {Constants.otp.enterOtp}
                                </h2>
                                <p className="text-center font-medium text-gray-800 mb-6">
                                    {phoneNumber}
                                </p>

                                <div className="flex justify-center space-x-4 mb-6">
                                    {otp.map((data, index) => (
                                        <input
                                            key={index}
                                            type="text"
                                            maxLength="1"
                                            value={data}
                                            onChange={(e) => handleChange(e.target, index)}
                                            className={data != '' ? "w-12 h-12 border border-gray-600 rounded-md text-center text-lg focus:outline-none focus:ring-2 focus:ring-green-500" :
                                                "w-12 h-12 border border-gray-300 rounded-md text-center text-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                                            }
                                        />
                                    ))}
                                </div>

                                <p className="text-center text-gray-500 text-sm mb-4">
                                    {Constants.otp.didnotget}
                                    <span className={timer > 0 ? "font-semibold text-blue-header" : "font-semibold text-blue-header hover:underline"}>
                                        {timer > 0 ? formatTimer(timer) :
                                            <a href="#" className="text-blue-header hover:underline"
                                            onClick={(e) => { handleGetOtpClick()
                                            }}>
                                                {Constants.otp.resendCode}
                                            </a>
                                        }
                                    </span>
                                    {/* {timer == 0 && <p className="font-semibold text-blue-header hover:underline">Resend Code On WhatsApp</p>}                            */}
                                     </p>

                                <button
                                    type="button"
                                    className={allValid ? "w-full py-3 bg-blue-header text-white rounded-md hover:bg-blue-opacityHeader flex items-center justify-center" : "w-full py-3 bg-gray-300 text-gray-500 rounded-md cursor-not-allowed flex items-center justify-center"}
                                    onClick={() => { validateOtp() }}
                                    disabled={loginSucess || !otp.every((digit) => digit !== "") || onClikedVerifyOtp}
                                >
                                    {verified ? <ArrowsClockwise size={16} className="text-white animate-spin" /> : Constants.otp.verify}
                                </button>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    );
}